import BurgerMenu from '../plugins/burgerMenuPlugin';
import Collapsible from '../plugins/collapsiblePlugin';
export default function initMobileNav() {
  const menuEl = document.querySelector('.nav__opener');
  const handelBurgerMenu = () => {
    const burgerMenu = new BurgerMenu('20000px');
  };
  const handelCollapsible = () => {
    document.querySelectorAll('.navbar li').forEach((item) => {
      if (item.querySelector(':scope > ul') || item.querySelector(':scope > div')) {
        const openClose = new Collapsible({
          holder: item,
          opener: '> a',
          slide: '> div',
          breakpoint: '1024px',
        });
      }
    });
  };
  const handelNoScroll = () => {
    if (!document.body.classList.contains('nav__active')) {
      document.body.classList.remove('no--scroll');
    } else {
      document.body.classList.add('no--scroll');
    }
  };

  handelBurgerMenu();
  handelCollapsible();
  menuEl.addEventListener('click', handelNoScroll);
}
